import ApiClient from "../helpers/ApiClient";

const baseContasAPagarEndpoint = (cnpj) => `/empresa/${cnpj}/contas_a_pagar`;

const getContas = (cnpj, params) =>
  ApiClient.apiClientDef.get(baseContasAPagarEndpoint(cnpj), { params });

const getImpostos = (cnpj, params) =>
  ApiClient.apiClientDef.get(`${baseContasAPagarEndpoint(cnpj)}/impostos`, {
    params,
  });

const getHonorarios = (cnpj, params) =>
  ApiClient.apiClientDef.get(`${baseContasAPagarEndpoint(cnpj)}/honorarios`, {
    params,
  });

const getProlabore = (cnpj, params) =>
  ApiClient.apiClientDef.get(`${baseContasAPagarEndpoint(cnpj)}/prolabore`, {
    params,
  });

const getFolhaPagamento = (cnpj, params) =>
  ApiClient.apiClientDef.get(
    `${baseContasAPagarEndpoint(cnpj)}/folha_pagamento`,
    {
      params,
    }
  );

const postImpostos = (cnpj, data) =>
  ApiClient.apiClientDef.post(
    `${baseContasAPagarEndpoint(cnpj)}/impostos`,
    data
  );

const postProlabore = (cnpj, data) =>
  ApiClient.apiClientDef.post(
    `${baseContasAPagarEndpoint(cnpj)}/prolabore`,
    data
  );

const postFolhaPagamento = (cnpj, data) =>
  ApiClient.apiClientDef.post(
    `${baseContasAPagarEndpoint(cnpj)}/folha_pagamento`,
    data
  );

const deleteImposto = (cnpj, uid) =>
  ApiClient.apiClientDef.delete(
    `${baseContasAPagarEndpoint(cnpj)}/impostos/${uid}`
  );

const deleteProlabore = (cnpj, uid) =>
  ApiClient.apiClientDef.delete(
    `${baseContasAPagarEndpoint(cnpj)}/prolabore/${uid}`
  );

const deleteFolhaPagamento = (cnpj, uid) =>
  ApiClient.apiClientDef.delete(
    `${baseContasAPagarEndpoint(cnpj)}/folha_pagamento/${uid}`
  );

const putImpostos = (cnpj, data) =>
  ApiClient.apiClientDef.put(
    `${baseContasAPagarEndpoint(cnpj)}/impostos`,
    data
  );

const putProlabore = (cnpj, data) =>
  ApiClient.apiClientDef.put(
    `${baseContasAPagarEndpoint(cnpj)}/prolabore`,
    data
  );

const putFolhaPagamento = (cnpj, data) =>
  ApiClient.apiClientDef.put(
    `${baseContasAPagarEndpoint(cnpj)}/folha_pagamento`,
    data
  );

const solicitarRecalculoImposto = (cnpj, data) =>
  ApiClient.apiClientDef.post(
    `${baseContasAPagarEndpoint(cnpj)}/impostos/solicitar_recalculo/`,
    data
  );

const getInformacoesArquivo = (cnpj, data) =>
  ApiClient.apiClientDef.post(
    `${baseContasAPagarEndpoint(cnpj)}/impostos/informacoes/`,
    data
  );

const substituirImposto = (cnpj, uid, data) =>
  ApiClient.apiClientDef.put(
    `${baseContasAPagarEndpoint(cnpj)}/impostos/${uid}`,
    data
  );

const substituirHonorario = (cnpj, uid, data) =>
  ApiClient.apiClientDef.post(
    `${baseContasAPagarEndpoint(cnpj)}/honorarios/${uid}`,
    data
  );

const downloadMassa = (data) =>
  ApiClient.backendClient.post(
    `contabilidade/contasAPagar/ContasAPagar/downloadMassa`,
    data,
    { responseType: "arraybuffer" }
  );

const excluirHistorico = (cnpj, uid, data) =>
  ApiClient.apiClientDef.put(
    `${baseContasAPagarEndpoint(cnpj)}/excluirHistorico/${uid}`,
    data
  );

const recalcularImpostoAutomatico = (cnpj, data) =>
  ApiClient.apiClientDef.post(`/empresa/${cnpj}/recalcular/`, data);

const contasAPagarApiClient = {
  getContas,
  getImpostos,
  getHonorarios,
  getProlabore,
  getFolhaPagamento,
  postImpostos,
  postProlabore,
  postFolhaPagamento,
  deleteImposto,
  deleteProlabore,
  deleteFolhaPagamento,
  putImpostos,
  putProlabore,
  putFolhaPagamento,
  solicitarRecalculoImposto,
  getInformacoesArquivo,
  substituirImposto,
  substituirHonorario,
  downloadMassa,
  excluirHistorico,
  recalcularImpostoAutomatico,
};
export default contasAPagarApiClient;
